module.exports = [{"type":"title","text":"2024-11-15"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：新增‘切換保證金模式’接口。"},{"type":"html","text":"永續U本位：新增‘查詢保證金模式’接口。"},{"type":"html","text":"永續U本位：新增‘查詢聯合保證金規則’接口。"},{"type":"html","text":"永續U本位：新增‘查詢聯合保證金抵押資產情況’接口。"},{"type":"html","text":"永續U本位：一個websocket限制最多200個topic，超過將返回80403錯誤碼。"},{"type":"html","text":"永續U本位：一個IP限制最多60個websocket，超過將建立連結失敗。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-11-15.json
// module id = aAh/
// module chunks = 3